<template>
  <div class="row">
    <div class="col-md-12">
      <section class="panel">
        <header class="panel-heading">
          <h2 class="panel-title">資料輸出</h2>
        </header>
        <div class="panel-body container-fluid">
          <div class="form-inline">
            <div class="row form-group">
              <div class="col-md-12 form-group">
                <label for="id" class="column-required">報 表 : </label>
                <select id="id" name="id" v-validate="'required'" v-model="exportForm.id" class="form-control"
                        :style="{width:'auto', display:'inline-block'}">
                  <option value="">請選擇</option>
                  <option value="1">教育部匯報格式</option>
                </select>
              </div>
            </div>
            <div class="btn-group">
              <button @click="handleExport" class="btn s_btn_b">匯出</button>
            </div>
          </div>
        </div>
      </section>
      <section class="panel">
        <header class="panel-heading">
          <h2 class="panel-title">資料匯入</h2>
        </header>
        <div class="panel-body container-fluid">
          <div class="row form-group">
            <div class="col-md-12 form-group">
              <label for="fia">財稅中心審核資料:</label>
              <input type="file" ref="fiaFile" name="fia" id="fia" :style="{width:'auto', display:'inline-block'}"/>

            </div>
            <div class="col-md-12 form-group">
              <label for="subsidy">補助金發放部別及金額:</label>
              <input type="file" ref="subsidyFile" name="subsidy" id="subsidy"
                     :style="{width:'auto', display:'inline-block'}"/>
            </div>
          </div>
          <div class="btn-group">
            <button @click="handleUpload" class="btn s_btn_b">上傳</button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exportForm: {
        id: 1
      }
    }
  },
  methods: {
    handleExport() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const api = `/api/weak/export/report/${this.exportForm.id}`;
          this.$axios.get(api, {
            responseType: 'blob'
          }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `檔案輸出教育部匯報格式_${this.customFormatter(new Date(), "YYYYMMDD")}.csv`);
            document.body.appendChild(link);
            link.click();
          });
        } else {
          bootbox.alert("請選擇匯出的報表")
        }
      });
    },
    handleUpload() {
      const fiaFile = this.$refs.fiaFile.files[0];
      const subsidyFile = this.$refs.subsidyFile.files[0];
      if (!fiaFile && !subsidyFile) {
        bootbox.alert("尚未選擇任何檔案");
        return;
      }

      const api = "/api/weak/import/report";

      let formData = new FormData();
      formData.append('fiaFile', fiaFile);
      formData.append('subsidyFile', subsidyFile);

      this.$axios.post(api, formData).then(resp => {
        if (resp.data.status == "success") {
          bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
        } else {
          bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
        }
        this.$refs.fiaFile.value = null;
        this.$refs.subsidyFile.value = null;
      });
    }
  }
}
</script>

<style scoped>
</style>
